// extracted by mini-css-extract-plugin
module.exports = {"container":"container-MbhXF","textContainer":"textContainer-1Uas0","label":"label-2JoYX","ageLimit":"ageLimit-161He"};